export default "__VITE_ASSET__WcdxErhF__"